import { Building2, HardHat, TreePine, Users } from 'lucide-react';

const useCases = [
  {
    icon: Building2,
    title: 'Emlakçılar & Brokerlar',
    description: 'Portföylerinizi profesyonel videolarla sergileyin. Müşterileriniz gayrimenkulü uzaktan keşfetsin. Satış sürecini hızlandırın.',
    benefits: ['Portföy farklılaştırma', 'Uzaktan müşteri kazanımı', 'Daha hızlı satış'],
    image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=600&q=80',
  },
  {
    icon: HardHat,
    title: 'Müteahhitler & İnşaat Firmaları',
    description: 'Proje tanıtımları için etkileyici sunum videoları oluşturun. Yatırımcılara ve alıcılara profesyonel içerikler sunun.',
    benefits: ['Proje lansman videoları', 'Yatırımcı sunumları', 'Şantiye takibi'],
    image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=600&q=80',
  },
  {
    icon: TreePine,
    title: 'Arsa Danışmanları',
    description: 'Parsel sınırlarını net şekilde gösteren harita videoları üretin. TKGM entegrasyonu ile tapu bilgilerini görselleştirin.',
    benefits: ['Parsel sınır gösterimi', 'Tapu analizi', 'Bölge potansiyeli'],
    image: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=600&q=80',
  },
  {
    icon: Users,
    title: 'Gayrimenkul Yatırımcıları',
    description: 'Yatırım yapacağınız bölgeleri detaylı analiz edin. Çevredeki POI\'leri keşfedin ve kararlarınızı verilerle destekleyin.',
    benefits: ['Bölge analizi', 'Yatırım raporları', 'Risk değerlendirme'],
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600&q=80',
  },
];

export default function UseCases() {
  return (
    <section id="use-cases" className="section-padding bg-slate-50 dark:bg-slate-900/50">
      <div className="container-custom">
        <div className="text-center mb-16">
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full 
                          bg-primary/10 text-primary text-sm font-semibold mb-4">
            Kullanım Senaryoları
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black mb-4 text-slate-900 dark:text-white">
            Kimler <span className="gradient-text">Kullanıyor?</span>
          </h2>
          <p className="text-slate-600 dark:text-slate-400 max-w-2xl mx-auto text-lg">
            Maplio, gayrimenkul sektöründeki farklı profesyoneller için çözümler sunar.
          </p>
        </div>

        <div className="space-y-12">
          {useCases.map((useCase, index) => (
            <div
              key={useCase.title}
              className={`flex flex-col ${
                index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
              } gap-8 lg:gap-12 items-center`}
            >
              {/* Image */}
              <div className="w-full lg:w-1/2">
                <div className="relative rounded-2xl overflow-hidden shadow-xl group">
                  <img
                    src={useCase.image}
                    alt={useCase.title}
                    className="w-full aspect-[4/3] object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                </div>
              </div>

              {/* Content */}
              <div className="w-full lg:w-1/2">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 rounded-xl bg-primary/10 text-primary 
                                  flex items-center justify-center">
                    <useCase.icon className="w-6 h-6" />
                  </div>
                  <h3 className="text-2xl font-bold text-slate-900 dark:text-white">
                    {useCase.title}
                  </h3>
                </div>
                <p className="text-slate-600 dark:text-slate-400 mb-6 leading-relaxed text-lg">
                  {useCase.description}
                </p>
                <ul className="space-y-3">
                  {useCase.benefits.map((benefit) => (
                    <li key={benefit} className="flex items-center gap-3">
                      <span className="w-1.5 h-1.5 rounded-full bg-primary flex-shrink-0" />
                      <span className="text-slate-700 dark:text-slate-300">{benefit}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
